import MsDefenderIntegration from './MsDefenderIntegration';

export { MsDefenderIntegration };
export default MsDefenderIntegration;
